module.exports = __webpack_public_path__ + "img/bg.db550c0a.png";